import React, { useRef, useState } from "react";
import styles from "./FollowUpModalStyles.module.css";
import { Modal, ModalBody } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { seekerFollowUp } from "../../../API/api";
import { recommendData } from "../../../Action/actions";
import { replaceContentEditableText } from "../../../utils";
import { toast } from "react-toastify";
import AttachmentBox from "../../AttachmentBox/AttachmentBox";
import Button from "../../../NewComponent/Button/Button";
import Button2 from "../../../NewComponent/Button2/Button2";
import { ModalHeader } from "../../../Constants";

export default function FollowUpModal() {
    const modalState = useSelector((state) => state.domain);
    const dispatch = useDispatch();
    const { advanceFilterModalToggle, updateSelectedAnswer, notificationsDataRecommend } = bindActionCreators(Actions, dispatch);
    const questionText = useSelector((state) => state.recommend.data.question);
    const [text, setText] = useState('');
    const selectedAns = useSelector((state) => state.search);
    const data = useSelector((state) => state.recommend.data);
    const answerData = useSelector((state)=>state.recommend.data);
    const attachmentsData = useSelector((state)=>state.recommend)

    const onChangeAdditionalTextFollowUp = (e) => {
        setText(e.target.value);
    }

    const followUpToast = () => {
        return (
            <>
                <span style={{ fontSize: "12px", }}>
                    Your request for Follow-Up has been submitted successfully.
                </span>
            </>
        );
    };

    const followUpPayloadData = () => {
        const obj = {
            answerUuid: selectedAns.selectedAnswer.answerUuid,
            additionalContext: text,
            originalExpert: true
        }
        seekerFollowUp(obj).then((res) => {
            if (res===undefined) return;
            if (res.data.success || res.data.data !== undefined) {
                
                answerData.answers.filter(obb=>{
                    if(obb.answerUuid === obj.answerUuid){
                        obb.userInitiatedCuration = true;
                    }
                })
                notificationsDataRecommend(answerData);
                advanceFilterModalToggle({ bool: false, value: "" })
                recommendData(res.data.data);
                toast.success(followUpToast(), {
                    position: toast.POSITION.TOP_RIGHT,
                  });
            }
        }).catch((err) => console.log(err));
    }

    const askTheTeamPayloadData = () => {
        const obj = {
            answerUuid: selectedAns.selectedAnswer.answerUuid,
            additionalContext: text,
            originalExpert: false,
        }
        seekerFollowUp(obj).then((res) => {
            if (res===undefined) return;
            if (res.data.success || res.data.data !== undefined) {
                answerData.answers.filter(obb=>{
                    if(obb.answerUuid === obj.answerUuid){
                        obb.userInitiatedCuration = true;
                    }
                })
                notificationsDataRecommend(answerData);
                advanceFilterModalToggle({ bool: false, value: "" });
                recommendData(res.data.data);
                toast.success(followUpToast(), {
                    position: toast.POSITION.TOP_RIGHT,
                  });
            }
        }).catch((err) => console.log(err));

    }
    return (
        <Modal
            show={modalState.modalState}
            onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
            centered={true}
            size={"lg"}
            dialogClassName={styles.modalDialog}
            scrollable
        >
            <Modal.Header closeButton>
                <Modal.Title style={ModalHeader.styles}>
                    <span className="fa fa-users"></span>
                    &nbsp;&nbsp;Request for Follow-Up
                </Modal.Title>
            </Modal.Header>
            <ModalBody>
                <div className="col-md-12 col-lg-12">
                    <h2 className={`mb-3`} style={{color:'rgb(42, 54, 74)',fontSize:'20px'}}>
                        {questionText}
                    </h2>
                    {
                        attachmentsData.seekerAttachments && attachmentsData.seekerAttachments.length > 0 &&
                        (
                            <div style={{ marginBottom: '7px' }}>
                                {attachmentsData.seekerAttachments.map((obj, ind) => {
                                    return (
                                        <AttachmentBox attachment={obj} key={ind} />
                                    )
                                })}
                            </div>
                        )
                    }
                    <div className={styles.answerText} dangerouslySetInnerHTML={{ __html: replaceContentEditableText(selectedAns.selectedAnswer.answer) }} ></div>
                    <p className={styles.followUpBranding}>Follow-up reason?</p>
                    <textarea style={{ width: "100%", borderRadius: "6px", padding: "5px", fontSize: "14px",outline:"none", borderColor:'lightgrey' }} placeholder="Share with Expert your reason for request for follow-up" onChange={(e) => onChangeAdditionalTextFollowUp(e)} />
                    <div class="text-center mb-20 mt-2" style={{display:'flex',gap:'5px',justifyContent:'flex-end',gap:'5px'}}>
                        <Button2 type="dark" children={'Cancel'} onClickFunc={()=>advanceFilterModalToggle({ bool: false, value: "" })} />
                        <Button2 type="dark" children='Ask the Team' onClickFunc={()=>askTheTeamPayloadData()} />
                        <Button onClickFunc={()=>followUpPayloadData()} type={'primary'} text={`Ask${" "}${selectedAns.selectedAnswer.expertFirstName}`} />
                    </div>
                </div>
            </ModalBody>
        </Modal>
    )
}